/**
 * "Save restaurant" intent — preserved across the signup redirect for anonymous users.
 *
 * Mirrors menuScanIntent: an anonymous user taps Save, we stash the intent, route them through
 * create-account, then BaseLayout consumes it post-signup to run the save and return them to the
 * page they came from.
 */
const PENDING_SAVE_RESTAURANT_INTENT_KEY = 'pending_save_restaurant_intent'

export interface PendingSaveRestaurantIntent {
  alias: string
  restaurantId?: string
  recommendationId?: string
  name?: string
  returnRoute: string
}

export function getPendingSaveRestaurantIntent(): PendingSaveRestaurantIntent | null {
  try {
    const raw = sessionStorage.getItem(PENDING_SAVE_RESTAURANT_INTENT_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as PendingSaveRestaurantIntent
    if (!parsed?.alias) return null
    return { ...parsed, returnRoute: parsed.returnRoute ?? '/' }
  } catch {
    return null
  }
}

export function setPendingSaveRestaurantIntent(intent: PendingSaveRestaurantIntent): void {
  try {
    sessionStorage.setItem(PENDING_SAVE_RESTAURANT_INTENT_KEY, JSON.stringify(intent))
  } catch {
    // ignore
  }
}

export function clearPendingSaveRestaurantIntent(): void {
  try {
    sessionStorage.removeItem(PENDING_SAVE_RESTAURANT_INTENT_KEY)
  } catch {
    // ignore
  }
}
